(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["based-countdown"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.based-countdown').forEach(function (root) {
      var target = root.getAttribute('data-target');
      if (!target) return;
      var endAt = Date.parse(target);
      if (isNaN(endAt)) return;

      var dEl = root.querySelector('[data-countdown-days]');
      var hEl = root.querySelector('[data-countdown-hours]');
      var mEl = root.querySelector('[data-countdown-minutes]');
      var sEl = root.querySelector('[data-countdown-seconds]');
      var endMsg = root.querySelector('[data-countdown-end-message]');
      var cells = root.querySelector('.based-countdown__cells');

      function tick() {
        var now = Date.now();
        var diff = endAt - now;
        if (diff <= 0) {
          if (cells) cells.hidden = true;
          if (endMsg) endMsg.hidden = false;
          return;
        }
        var days = Math.floor(diff / 86400000);
        var hours = Math.floor((diff % 86400000) / 3600000);
        var minutes = Math.floor((diff % 3600000) / 60000);
        var seconds = Math.floor((diff % 60000) / 1000);
        if (dEl) dEl.textContent = days;
        if (hEl) hEl.textContent = ('0' + hours).slice(-2);
        if (mEl) mEl.textContent = ('0' + minutes).slice(-2);
        if (sEl) sEl.textContent = ('0' + seconds).slice(-2);
      }
      tick();
      setInterval(tick, 1000);
    });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["based-pdp-buy-box"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.based-buybox').forEach(function (root) {
      var hiddenId = root.querySelector('[data-based-selected-variant-id]');
      var atc = root.querySelector('[data-based-atc]');
      var qtyInput = root.querySelector('[data-based-qty-input]');
      var decBtn = root.querySelector('[data-based-qty-decrement]');
      var incBtn = root.querySelector('[data-based-qty-increment]');
      function formatMoney(cents) {
        var amount = Number(cents || 0) / 100;
        try {
          return new Intl.NumberFormat(document.documentElement.lang || undefined, {
            style: 'currency',
            currency: root.dataset.currencyCode || 'USD'
          }).format(amount);
        } catch (e) {
          return (root.dataset.currencySymbol || '$') + amount.toFixed(2);
        }
      }
      function igPriceCents(variantId, nativeCents) {
        try {
          var api = window.igData && window.igData.price;
          if (api && typeof api.getPriceByVariantId === 'function') {
            var value = api.getPriceByVariantId(variantId);
            if (value != null && value !== '') {
              var dollars = Number(value);
              if (isFinite(dollars)) return Math.round(dollars * 100);
            }
          }
        } catch (e) {}
        return Number(nativeCents || 0);
      }
      function igCompareCents(variantId, nativeCents) {
        try {
          var api = window.igData && window.igData.price;
          if (api && typeof api.getComparePriceByVariantId === 'function') {
            var value = api.getComparePriceByVariantId(variantId);
            if (value != null && value !== '') {
              var dollars = Number(value);
              if (isFinite(dollars)) return Math.round(dollars * 100);
            }
          }
        } catch (e) {}
        return Number(nativeCents || 0);
      }
      function ensureATCParts(button) {
        var labelEl = button.querySelector('.based-buybox__atc-label');
        var priceEl = button.querySelector('.based-buybox__atc-price');
        var compareEl = button.querySelector('[data-based-atc-compare]');
        if (labelEl && priceEl && compareEl) return { label: labelEl, price: priceEl, compare: compareEl };
        button.textContent = '';
        labelEl = document.createElement('span');
        labelEl.className = 'based-buybox__atc-label';
        priceEl = document.createElement('span');
        priceEl.className = 'based-buybox__atc-price igPrice';
        priceEl.setAttribute('data-based-atc-price', '');
        compareEl = document.createElement('s');
        compareEl.className = 'based-buybox__atc-compare igComparePrice';
        compareEl.setAttribute('data-based-atc-compare', '');
        button.appendChild(labelEl);
        button.appendChild(priceEl);
        button.appendChild(compareEl);
        return { label: labelEl, price: priceEl, compare: compareEl };
      }
      function renderATCFromCard(card) {
        if (!atc || !card) return;
        var available = card.dataset.variantAvailable === 'true';
        var state = card.dataset.variantPurchaseState || (available ? 'add_to_cart' : 'out_of_stock');
        var parts = ensureATCParts(atc);
        var variantId = card.dataset.variantId;
        var p = igPriceCents(variantId, card.dataset.variantPrice);
        var cmp = igCompareCents(variantId, card.dataset.variantCompareAt);
        var pricing = {
          formattedPrice: state === 'add_to_cart' ? formatMoney(p) : '',
          formattedComparePrice: state === 'add_to_cart' && cmp > p ? formatMoney(cmp) : ''
        };
        parts.price.setAttribute('data-product-id', root.dataset.productId || '');
        parts.price.setAttribute('data-variant-id', variantId);
        parts.compare.setAttribute('data-product-id', root.dataset.productId || '');
        parts.compare.setAttribute('data-variant-id', variantId);
        atc.dataset.purchaseState = state;
        atc.classList.toggle('based-buybox__atc--notify', state === 'notify_me');
        atc.classList.toggle('based-klaviyo-notify-trigger', state === 'notify_me');
        atc.setAttribute('type', state === 'notify_me' ? 'button' : 'submit');
        atc.disabled = state === 'out_of_stock';
        if (state === 'out_of_stock') {
          parts.label.textContent = atc.dataset.oosLabel || 'SOLD OUT';
          parts.price.textContent = '';
          parts.compare.textContent = '';
          return pricing;
        }
        if (state === 'notify_me') {
          parts.label.textContent = atc.dataset.notifyLabel || 'NOTIFY ME';
          parts.price.textContent = '';
          parts.compare.textContent = '';
          return pricing;
        }
        parts.label.textContent = atc.dataset.label || 'ADD TO CART';
        parts.price.textContent = pricing.formattedPrice;
        parts.compare.textContent = pricing.formattedComparePrice;
        return pricing;
      }

      root.querySelectorAll('[data-based-variant-card]').forEach(function (card) {
        card.addEventListener('click', function () {
          if (card.classList.contains('based-buybox__variant-card--selected')) return;
          root.querySelectorAll('[data-based-variant-card]').forEach(function (c) {
            c.classList.remove('based-buybox__variant-card--selected');
            var r = c.querySelector('input[type=radio]');
            if (r) r.checked = false;
          });
          card.classList.add('based-buybox__variant-card--selected');
          var radio = card.querySelector('input[type=radio]');
          if (radio) radio.checked = true;
          if (hiddenId) hiddenId.value = card.dataset.variantId;
          var pricing = renderATCFromCard(card);
          root.dispatchEvent(new CustomEvent('based:variant-change', {
            bubbles: true,
            detail: {
              productId: root.dataset.productId,
              variantId: card.dataset.variantId,
              purchaseState: card.dataset.variantPurchaseState,
              formattedPrice: pricing && pricing.formattedPrice,
              formattedComparePrice: pricing && pricing.formattedComparePrice
            }
          }));
        });
      });

      if (decBtn && qtyInput) decBtn.addEventListener('click', function () {
        var v = parseInt(qtyInput.value, 10) || 1;
        if (v > 1) qtyInput.value = v - 1;
      });
      if (incBtn && qtyInput) incBtn.addEventListener('click', function () {
        qtyInput.value = (parseInt(qtyInput.value, 10) || 1) + 1;
      });

      if (atc) {
        atc.addEventListener('click', function (event) {
          if (atc.dataset.purchaseState !== 'notify_me') return;
          event.preventDefault();
          var formId = atc.dataset.klaviyoFormId;
          if (!formId) return;
          window._klOnsite = window._klOnsite || [];
          window._klOnsite.push(['openForm', formId]);
        });
      }
    });

    if (window.location.search.indexOf('notify=1') !== -1) {
      window.setTimeout(function () {
        var trigger = document.querySelector('.based-klaviyo-notify-trigger');
        if (trigger) {
          var motionOkay = !window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          try { trigger.scrollIntoView({ behavior: motionOkay ? 'smooth' : 'auto', block: 'center' }); } catch (e) {}
          try { trigger.focus({ preventScroll: true }); } catch (e) {}
          try { trigger.click(); } catch (e) {}
        }
      }, 1200);
    }
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["based-pdp-demo-video"] && !Shopify.designMode) return;
  try {
    (() => {
    if (customElements.get('based-demo-video')) return;

    const REDUCED_MOTION = '(prefers-reduced-motion: reduce)';

    class BasedDemoVideo extends HTMLElement {
      constructor() {
        super();
        // Bound once, on the instance. Re-binding per connection is what made
        // the old listeners un-removable and let them stack on reconnect.
        this.onClick = this.onClick.bind(this);
        this.onDialogClose = this.onDialogClose.bind(this);
        this.onNativeDialogClose = this.onNativeDialogClose.bind(this);
        this.onMediaError = this.onMediaError.bind(this);
        this.onMutate = this.onMutate.bind(this);
        this.observer = null;
        this.mutationObserver = null;
        this.wired = false;
        this.hydrated = false;
        this.inView = false;
        this.userPaused = false;
        this.nativeDialogFallback = false;
        this.lastSrc = '';
        this.lastPoster = '';
      }

      connectedCallback() {
        // Idempotent: a detach/reattach (or a morph that relocates the node)
        // must not add a second set of listeners or a second observer.
        if (this.wired) return;
        this.wired = true;

        this.addEventListener('click', this.onClick);

        const host = this.dialogHost();
        if (host) host.addEventListener('dialog:close', this.onDialogClose);

        const dialog = this.dialogEl();
        if (dialog) dialog.addEventListener('close', this.onNativeDialogClose);

        const modal = this.modalPlayer();
        if (modal) modal.addEventListener('error', this.onMediaError);

        const player = this.player();
        this.lastSrc = player ? (player.getAttribute('data-src') || '') : '';
        this.lastPoster = player ? (player.getAttribute('data-poster') || '') : '';

        // Hydration is gated on real visibility. A held block is display:none,
        // which can never intersect, so control traffic issues no media or
        // poster request at all.
        if ('IntersectionObserver' in window) {
          this.observer = new IntersectionObserver(
            (entries) => {
              entries.forEach((entry) => {
                this.inView = entry.isIntersecting;
                if (entry.isIntersecting) {
                  this.hydrateInline();
                  this.playInline();
                } else {
                  this.pauseInline();
                }
              });
            },
            { threshold: 0.35 }
          );
          this.observer.observe(this);
        } else {
          // Fail closed for the experiment on legacy browsers. CSS hiding does
          // not prevent a programmatically assigned src from being requested,
          // so hydrate only when the treatment has made the block renderable.
          const rendered = this.getClientRects().length > 0 && window.getComputedStyle(this).display !== 'none';
          if (rendered) {
            this.inView = true;
            this.hydrateInline();
            this.playInline();
          }
        }

        // A connected-product morph rewrites this subtree in place. Watch for
        // the source actually changing rather than assuming a morph happened.
        if ('MutationObserver' in window) {
          this.mutationObserver = new MutationObserver(this.onMutate);
          this.mutationObserver.observe(this, {
            subtree: true,
            childList: true,
            attributes: true,
            // Shopify's morph removes runtime src/poster attributes because
            // they are intentionally absent from the server markup. Observe
            // those removals as well as changes to the inert source data.
            attributeFilter: ['data-src', 'data-poster', 'src', 'poster'],
          });
        }
      }

      disconnectedCallback() {
        this.wired = false;
        this.removeEventListener('click', this.onClick);

        const host = this.dialogHost();
        if (host) host.removeEventListener('dialog:close', this.onDialogClose);

        const dialog = this.dialogEl();
        if (dialog) dialog.removeEventListener('close', this.onNativeDialogClose);

        const modal = this.modalPlayer();
        if (modal) {
          modal.removeEventListener('error', this.onMediaError);
          // The dialog:close listener is removed during teardown, so stop the
          // media explicitly instead of relying on that event to do it.
          modal.pause();
          try { modal.currentTime = 0; } catch (e) { /* not seekable */ }
          modal.removeAttribute('src');
          modal.removeAttribute('poster');
        }
        const captions = this.captionsTrack();
        if (captions) captions.removeAttribute('src');
        this.pauseInline();
        this.hydrated = false;
        this.inView = false;

        if (this.observer) {
          this.observer.disconnect();
          this.observer = null;
        }
        if (this.mutationObserver) {
          this.mutationObserver.disconnect();
          this.mutationObserver = null;
        }

        // The dialog owns the body scroll lock, so closing it here is what
        // guarantees scrolling is restored if the component is torn down while
        // open. Nothing else touches document.body.
        this.closeDialog();
      }

      /* ── element lookups (always live: a morph replaces these nodes) ── */
      dialogHost() { return this.querySelector('dialog-component'); }
      dialogEl() { return this.querySelector('[data-demo-lightbox]'); }
      player() { return this.querySelector('[data-demo-player]'); }
      modalPlayer() { return this.querySelector('[data-demo-lightbox-player]'); }
      captionsTrack() { return this.querySelector('[data-demo-captions]'); }
      motionButton() { return this.querySelector('[data-demo-motion]'); }
      errorEl() { return this.querySelector('[data-demo-error]'); }

      prefersReducedMotion() {
        return window.matchMedia && window.matchMedia(REDUCED_MOTION).matches;
      }

      /* ── inline preview ─────────────────────────────────────────────── */
      hydrateInline() {
        const video = this.player();
        if (!video || this.hydrated) return;
        const src = video.getAttribute('data-src');
        if (!src) return;
        const poster = video.getAttribute('data-poster');
        if (poster) video.setAttribute('poster', poster);
        // With no poster the tile would be black until playback paints a
        // frame, which for a reduced-motion visitor is never. Asking for
        // metadata gets the first frame up without autoplaying anything.
        if (!poster) video.setAttribute('preload', 'metadata');
        video.muted = true;
        video.setAttribute('src', src);
        this.hydrated = true;
      }

      playInline() {
        const video = this.player();
        if (!video || !this.hydrated) return;
        if (this.prefersReducedMotion() || this.userPaused) return;
        if (this.dialogIsOpen()) return;
        const attempt = video.play();
        if (attempt && typeof attempt.then === 'function') {
          attempt.then(() => this.showMotionControl(true)).catch(() => {});
        } else {
          this.showMotionControl(true);
        }
      }

      pauseInline() {
        const video = this.player();
        if (video) video.pause();
      }

      /* The looping preview needs a keyboard-operable way to stop it. The
         control only appears once playback has actually started. */
      showMotionControl(on) {
        const button = this.motionButton();
        if (!button) return;
        if (on) button.removeAttribute('hidden');
        else button.setAttribute('hidden', '');
      }

      toggleMotion() {
        const video = this.player();
        const button = this.motionButton();
        if (!video || !button) return;
        this.userPaused = !this.userPaused;
        const label = button.querySelector('[data-demo-motion-label]');
        if (this.userPaused) {
          video.pause();
          button.setAttribute('aria-pressed', 'true');
          if (label) label.textContent = 'Play preview';
        } else {
          button.setAttribute('aria-pressed', 'false');
          if (label) label.textContent = 'Pause preview';
          this.playInline();
        }
      }

      /* ── modal ──────────────────────────────────────────────────────── */
      dialogIsOpen() {
        const dialog = this.dialogEl();
        return !!(dialog && dialog.open);
      }

      openDialog() {
        const host = this.dialogHost();
        const dialog = this.dialogEl();
        const modal = this.modalPlayer();
        if (!dialog || !modal) return;

        this.hideError();
        // The modal's media is hydrated ONLY here, by an accepted open action,
        // and always from the inline player's current data-src. That keeps the
        // two in step through a morph without a second source of truth.
        const video = this.player();
        const src = video ? video.getAttribute('data-src') : null;
        if (src && modal.getAttribute('src') !== src) {
          modal.setAttribute('src', src);
        }
        const poster = video ? video.getAttribute('data-poster') : null;
        // Synced unconditionally, not only when the src changed: two products
        // can share a video file and differ in poster.
        if (poster) modal.setAttribute('poster', poster);
        else modal.removeAttribute('poster');
        const captions = this.captionsTrack();
        const captionsSrc = captions ? captions.getAttribute('data-src') : null;
        if (captions && captionsSrc) captions.setAttribute('src', captionsSrc);

        this.pauseInline();

        if (host && typeof host.showDialog === 'function') {
          this.nativeDialogFallback = false;
          host.showDialog();
        } else if (typeof dialog.showModal === 'function' && !dialog.open) {
          // The dialog component failing to upgrade must not leave the CTA dead.
          this.nativeDialogFallback = true;
          dialog.showModal();
        }

        modal.muted = false;
        const restart = () => {
          try { modal.currentTime = 0; } catch (e) { /* not seekable yet */ }
        };
        if (modal.readyState >= 1) restart();
        else modal.addEventListener('loadedmetadata', restart, { once: true });

        const attempt = modal.play();
        if (attempt && typeof attempt.catch === 'function') {
          attempt.catch(() => this.showError());
        }
      }

      closeDialog() {
        const host = this.dialogHost();
        const dialog = this.dialogEl();
        if (!dialog) return;

        const wasOpen = dialog.open;
        if (host && typeof host.closeDialog === 'function') {
          // The host also owns an open request that may still be waiting on
          // requestAnimationFrame, before dialog.open becomes true.
          this.nativeDialogFallback = false;
          host.closeDialog();
          if (!wasOpen) this.onDialogClose();
        } else if (wasOpen) {
          // Fallback native close emits no dialog:close custom event, so run
          // the media teardown and preview-resume path explicitly.
          this.nativeDialogFallback = false;
          dialog.close();
          this.onDialogClose();
        } else {
          this.onDialogClose();
        }
      }

      /* Fires for Escape, the close button, and a click outside — the dialog
         component owns all three, so media teardown lives here rather than in
         three separate handlers. */
      onDialogClose() {
        const modal = this.modalPlayer();
        if (modal) {
          modal.pause();
          try { modal.currentTime = 0; } catch (e) { /* not seekable */ }
        }
        this.hideError();
        // The observer only fires on intersection changes, and closing an
        // overlay is not one, so the preview has to be resumed explicitly.
        if (this.inView) this.playInline();
      }

      onNativeDialogClose() {
        // The upgraded dialog host dispatches dialog:close after its own
        // teardown. Native close is only our signal when openDialog() had to
        // use the unupgraded fallback path.
        if (!this.nativeDialogFallback) return;
        this.nativeDialogFallback = false;
        this.onDialogClose();
      }

      showError() {
        const el = this.errorEl();
        if (el) el.removeAttribute('hidden');
      }

      hideError() {
        const el = this.errorEl();
        if (el) el.setAttribute('hidden', '');
      }

      onMediaError() {
        if (this.dialogIsOpen()) this.showError();
      }

      /* ── product morph ──────────────────────────────────────────────── */
      onMutate() {
        const video = this.player();
        if (!video) return;
        const src = video.getAttribute('data-src') || '';
        const poster = video.getAttribute('data-poster') || '';
        const sourceChanged = src !== this.lastSrc || poster !== this.lastPoster;
        const runtimeWasStripped = this.hydrated && (
          (video.getAttribute('src') || '') !== src ||
          (video.getAttribute('poster') || '') !== poster
        );

        this.lastSrc = src;
        this.lastPoster = poster;

        // A same-source product morph still strips the runtime src/poster
        // attributes because the server markup intentionally contains only
        // data-*. Without this check the component believes it is hydrated,
        // leaving both the inline and open modal players empty.
        if (!sourceChanged && !runtimeWasStripped) return;

        // The product changed underneath us. Cancel both an already-open
        // dialog and a showDialog() request still waiting on its animation
        // frame, then let the shopper reopen against the new product.
        this.closeDialog();

        const modal = this.modalPlayer();
        if (modal) {
          modal.pause();
          modal.removeAttribute('src');
          modal.removeAttribute('poster');
        }

        // Re-arm the inline player against the new source, and only restart it
        // if it is still eligible: in view, not reduced motion, not paused by
        // the shopper.
        this.hydrated = false;
        this.showMotionControl(false);
        if (this.inView) {
          this.hydrateInline();
          this.playInline();
        }
      }

      onClick(event) {
        const target = event.target;
        if (!target || !target.closest) return;
        if (target.closest('[data-demo-motion]')) {
          event.preventDefault();
          event.stopPropagation();
          this.toggleMotion();
          return;
        }
        if (target.closest('[data-demo-close]')) {
          event.preventDefault();
          this.closeDialog();
          return;
        }
        if (target.closest('[data-demo-open]')) {
          event.preventDefault();
          this.openDialog();
        }
      }
    }

    customElements.define('based-demo-video', BasedDemoVideo);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["based-product-media-gallery"] && !Shopify.designMode) return;
  try {
    (function () {
    document.querySelectorAll('.based-gallery').forEach(function (root) {
      var main = root.querySelector('[data-based-gallery-main]');
      var thumbs = root.querySelector('[data-based-gallery-thumbs]');
      if (!main) return;

      var slides = Array.from(main.querySelectorAll('[data-based-slide-id]'));
      var thumbBtns = thumbs ? Array.from(thumbs.querySelectorAll('[data-based-thumb-id]')) : [];
      var productJsonPromise = null;

      function activate(id) {
        slides.forEach(function (s) {
          s.classList.toggle('based-gallery__slide--active', s.dataset.basedSlideId === id);
        });
        thumbBtns.forEach(function (t) {
          t.classList.toggle('based-gallery__thumb--active', t.dataset.basedThumbId === id);
        });
      }

      function fileKey(url) {
        if (!url) return '';
        return String(url).split('?')[0].split('/').pop();
      }

      function productJson() {
        if (!productJsonPromise) {
          productJsonPromise = fetch(window.location.pathname.replace(/\/$/, '') + '.js', {
            headers: { Accept: 'application/json' }
          }).then(function (res) {
            if (!res.ok) throw new Error('product json failed');
            return res.json();
          }).catch(function () { return null; });
        }
        return productJsonPromise;
      }

      function activateVariantImage(imageSrc) {
        var key = fileKey(imageSrc);
        if (!key) return false;
        var match = slides.find(function (slide) {
          var img = slide.querySelector('img');
          return img && fileKey(img.currentSrc || img.src) === key;
        });
        if (!match) return false;
        activate(match.dataset.basedSlideId);
        return true;
      }

      function activateVariantMedia(variantId, imageSrc) {
        if (!variantId) return;
        if (imageSrc && activateVariantImage(imageSrc)) return;
        productJson().then(function (product) {
          if (!product || !product.variants) return;
          var variant = product.variants.find(function (v) { return String(v.id) === String(variantId); });
          var featured = variant && variant.featured_image && variant.featured_image.src;
          activateVariantImage(featured);
        });
      }

      function currentIndex() {
        for (var i = 0; i < slides.length; i++) {
          if (slides[i].classList.contains('based-gallery__slide--active')) return i;
        }
        return 0;
      }

      function step(delta) {
        if (slides.length < 2) return;
        var n = slides.length;
        var i = (currentIndex() + delta + n) % n;
        activate(slides[i].dataset.basedSlideId);
      }

      thumbBtns.forEach(function (btn) {
        btn.addEventListener('click', function () { activate(btn.dataset.basedThumbId); });
      });

      var prev = root.querySelector('[data-based-gallery-prev]');
      var next = root.querySelector('[data-based-gallery-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      function syncSelectedVariantMedia() {
        var selectedInput = document.querySelector('[data-based-selected-variant-id]');
        if (selectedInput) activateVariantMedia(selectedInput.value);
      }
      syncSelectedVariantMedia();
      document.addEventListener('DOMContentLoaded', syncSelectedVariantMedia);
      setTimeout(syncSelectedVariantMedia, 250);
      setTimeout(syncSelectedVariantMedia, 1000);
      document.addEventListener('based:variant-change', function (event) {
        activateVariantMedia(
          event.detail && event.detail.variantId,
          event.detail && event.detail.imageSrc
        );
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
